import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { runtimeConfig } from './services/runtimeConfig';
import reportWebVitals from './reportWebVitals';
import { suppressConsoleOutput, restoreConsoleOutput } from './utils/consoleSuppress';
import './utils/mockAgents'; // registers window.askAldo.mockAgents helpers on localhost

// Allow full console output locally so debugging logs appear
if (process.env.NODE_ENV === 'production') {
  suppressConsoleOutput(true);
} else {
  restoreConsoleOutput();
}

const start = async () => {
  try {
    await runtimeConfig.initialize();
  } catch {}

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

start();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();